import React from 'react';
import { Link } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import { ReactComponent as ChevronRight } from 'images/shared/chevron-right-1.svg';

const CrumbText = ({ children, isActive }) => (
  <Typography
    variant='body1'
    fontFamily='Montserrat'
    color={!isActive ? 'primary.blue1' : ''}>
    {children}
  </Typography>
);

const Crumb = ({ crumb: { isActive, title, linkTo } }) =>
  Boolean(linkTo) && linkTo !== ''
    ? (
      <Link
        to={linkTo}
        data-testid={`breadcrumb-link-${title.toLowerCase().replace(' ', '-')}`}>
        <CrumbText
          isActive={isActive}>{title}</CrumbText>
      </Link>
    )
    : (
      <CrumbText
        isActive={isActive}>{title}</CrumbText>
    );

const Divider = () => (
  <Typography
    color='primary.blue1'>
    <ChevronRight
      data-testid='chevron-right-svg' width='6px'
    />
  </Typography>
);

const Breadcrumb = ({ crumbs }) => (
  <Stack
    alignItems='center'
    direction='row'
    m={{ xs: '15px', md: '20px 40px 50px 40px' }}
    spacing='10px'
    divider={<Divider />}
    sx={{ a: { textDecoration: 'none' } }}>
    {[
      { title: 'Homepage', isActive: false, linkTo: '/homepage' },
      ...crumbs,
    ].map((crumb, index) => (
      <div
        key={index}>
        <Crumb
          crumb={crumb}
        />
      </div>
    ))}
  </Stack>
);

export default Breadcrumb;
